var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionsAddMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 5.33333C10.0007 3.49239 8.50825 2 6.66732 2C4.82637 2 3.33398 3.49239 3.33398 5.33333C3.33398 7.17427 4.82637 8.66667 6.66732 8.66667C8.50825 8.66667 10.0007 7.17427 10.0007 5.33333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 5.33333C10.0007 3.49239 8.50825 2 6.66732 2C4.82637 2 3.33398 3.49239 3.33398 5.33333C3.33398 7.17427 4.82637 8.66667 6.66732 8.66667C8.50825 8.66667 10.0007 7.17427 10.0007 5.33333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 14.0007V9.33398M9.33398 11.6673H14.0007",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 14.0007V9.33398M9.33398 11.6673H14.0007",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3327C2 10.7553 4.08934 8.66602 6.66667 8.66602C7.65813 8.66602 8.57747 8.97522 9.33333 9.50248",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3327C2 10.7553 4.08934 8.66602 6.66667 8.66602C7.65813 8.66602 8.57747 8.97522 9.33333 9.50248",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsAddMembers);
export default __webpack_public_path__ + "static/media/permissions_add_members.67f6fedd18a52dc7ac34ec77ea3f19c3.svg";
export { ForwardRef as ReactComponent };